import Vue from 'vue';
import Loading from '@/components/elements/loading';
import InputSwitch from '@/components/forms/input-switch';
import ImageInput from '@/components/forms/image-input';
import InputSelect from '@/components/forms/input-select';
import InputWysiwyg from '@/components/forms/input-wysiwyg';
import NoContent from '@/components/elements/no-content';

Vue.component('loading', Loading);
Vue.component('input-switch', InputSwitch);
Vue.component('image-input', ImageInput);
Vue.component('input-select', InputSelect);
Vue.component('input-wysiwyg', InputWysiwyg);
Vue.component('no-content', NoContent);
